import React from "react";
import {SvgIconProps} from "@material-ui/core/SvgIcon";
import {Button, useTheme} from "@material-ui/core";
import FlexBox from "view/components/Layout/FlexBox";
import useStyles from "./styles";

export enum AssignToMode {
  BUILD_TYPE_AND_PACKAGES = "buildTypesAndPackages",
  EXHIBITORS = "exhibitors",
}

export enum PackageMode {
  EXCLUDE = "exclude",
  ASSIGN = "assign",
  NONE = "none",
}

export type AssignToModalForm = {
  buildTypes: string[];
  packageIds: string[];
  packageMode: PackageMode;
  assignToMode: AssignToMode;
  stands?: string[];
};

type PackageModeButtonProps = {
  text: string;
  isChosen: boolean;
  onClick: () => void;
  Icon: (props: SvgIconProps) => JSX.Element;
};

export const PackageModeButton = ({
  text,
  Icon,
  isChosen,
  onClick,
}: PackageModeButtonProps) => {
  const classes = useStyles();
  const theme = useTheme();
  return (
    <Button
      color="primary"
      className={`${classes.assignToPackageButton} ${
        isChosen
          ? classes.assignToPackageButtonActive
          : classes.assignToPackageButtonUnactive
      }`}
      onClick={onClick}
      variant="contained"
    >
      <FlexBox alignCenter gap={0.5}>
        <Icon htmlColor={isChosen ? theme.palette.primary.main : "gray"} />
        <span className={classes.assignToPackageText}>{text}</span>
      </FlexBox>
    </Button>
  );
};
